import { render, staticRenderFns } from "./NewFileForm.vue?vue&type=template&id=075c0c1f&scoped=true&"
import script from "./NewFileForm.vue?vue&type=script&lang=js&"
export * from "./NewFileForm.vue?vue&type=script&lang=js&"
import style0 from "./NewFileForm.vue?vue&type=style&index=0&id=075c0c1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075c0c1f",
  null
  
)

export default component.exports